class CartCarouselElement extends HTMLElement {
  constructor() {
    super();
    this.currentIndex = 0;
    this.isDragging = false;
    this.startX = 0;
    this.currentX = 0;
    this.translateX = 0;
    this.slideWidth = 0;
    this.maxIndex = 0;
    this.slides = [];
    this.track = null;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.track = this.querySelector(".carousel-track");
    this.slides = this.querySelectorAll(".carousel-slide");

    if (!this.track || this.slides.length === 0) {
      return;
    }
    this.calculateDimensions();
    this.bindEvents();
    this.updatePosition();

    window.addEventListener("resize", this.handleResize.bind(this));
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this.handleResize.bind(this));
  }

  handleResize() {
    this.calculateDimensions();
    this.updatePosition();
  }

  calculateDimensions() {
    const containerWidth = this.offsetWidth;
    const slideWidth = this.slides[0].offsetWidth;
    this.slideWidth = slideWidth;

    const slidesPerView = Math.floor(containerWidth / slideWidth);
    this.maxIndex = Math.max(0, this.slides.length - slidesPerView);
  }

  bindEvents() {
    this.track.addEventListener(
      "touchstart",
      this.handleTouchStart.bind(this),
      { passive: false }
    );
    this.track.addEventListener("touchmove", this.handleTouchMove.bind(this), {
      passive: false,
    });
    this.track.addEventListener("touchend", this.handleTouchEnd.bind(this), {
      passive: false,
    });

    this.track.addEventListener("mousedown", this.handleMouseDown.bind(this));
    this.track.addEventListener("mousemove", this.handleMouseMove.bind(this));
    this.track.addEventListener("mouseup", this.handleMouseUp.bind(this));
    this.track.addEventListener("mouseleave", this.handleMouseUp.bind(this));

    this.track.addEventListener("contextmenu", (e) => e.preventDefault());
  }

  handleTouchStart(e) {
    this.isDragging = true;
    this.startX = e.touches[0].clientX;
    this.track.classList.add("swiping");
    e.preventDefault();
  }

  handleTouchMove(e) {
    if (!this.isDragging) return;

    this.currentX = e.touches[0].clientX;
    const diffX = this.currentX - this.startX;
    const newTranslateX = this.translateX + diffX;

    const maxTranslate = 0;
    const minTranslate = -(this.maxIndex * this.slideWidth);
    const boundedTranslate = Math.max(
      minTranslate,
      Math.min(maxTranslate, newTranslateX)
    );

    this.track.style.transform = `translateX(${boundedTranslate}px)`;
    e.preventDefault();
  }

  handleTouchEnd(e) {
    if (!this.isDragging) return;

    this.isDragging = false;
    this.track.classList.remove("swiping");

    const diffX = this.currentX - this.startX;
    const threshold = this.slideWidth * 0.3;

    if (Math.abs(diffX) > threshold) {
      if (diffX > 0 && this.currentIndex > 0) {
        this.currentIndex--;
      } else if (diffX < 0 && this.currentIndex < this.maxIndex) {
        this.currentIndex++;
      }
    }

    this.updatePosition();
  }

  handleMouseDown(e) {
    this.isDragging = true;
    this.startX = e.clientX;
    this.track.classList.add("swiping");
    e.preventDefault();
  }

  handleMouseMove(e) {
    if (!this.isDragging) return;

    this.currentX = e.clientX;
    const diffX = this.currentX - this.startX;
    const newTranslateX = this.translateX + diffX;

    const maxTranslate = 0;
    const minTranslate = -(this.maxIndex * this.slideWidth);
    const boundedTranslate = Math.max(
      minTranslate,
      Math.min(maxTranslate, newTranslateX)
    );

    this.track.style.transform = `translateX(${boundedTranslate}px)`;
  }

  handleMouseUp(e) {
    if (!this.isDragging) return;

    this.isDragging = false;
    this.track.classList.remove("swiping");

    const diffX = this.currentX - this.startX;
    const threshold = this.slideWidth * 0.3;

    if (Math.abs(diffX) > threshold) {
      if (diffX > 0 && this.currentIndex > 0) {
        this.currentIndex--;
      } else if (diffX < 0 && this.currentIndex < this.maxIndex) {
        this.currentIndex++;
      }
    }

    this.updatePosition();
  }

  updatePosition() {
    this.translateX = -(this.currentIndex * this.slideWidth);
    this.track.style.transform = `translateX(${this.translateX}px)`;
  }

  next() {
    if (this.currentIndex < this.maxIndex) {
      this.currentIndex++;
      this.updatePosition();
    }
  }

  prev() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.updatePosition();
    }
  }

  goTo(index) {
    if (index >= 0 && index <= this.maxIndex) {
      this.currentIndex = index;
      this.updatePosition();
    }
  }
}

customElements.define("cart-carousel", CartCarouselElement);

function initCartCarousels() {
  const carouselElements = document.querySelectorAll("cart-carousel");
  carouselElements.forEach((element) => {
    if (!element.hasAttribute("data-carousel-initialized")) {
      element.setAttribute("data-carousel-initialized", "true");
    }
  });
}

function tryInit() {
  if (document.querySelector("cart-carousel")) {
    initCartCarousels();
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", tryInit);
} else {
  tryInit();
}

document.addEventListener("cart:opened", initCartCarousels);
document.addEventListener("cart:updated", initCartCarousels);

tryInit();
